module.exports = __webpack_public_path__ + "media/images/community_stories/your_community_6-001b54babe207cbab311bd59943c2668.jpg";